import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import { useController } from 'react-hook-form';

import { BaseDrawer } from 'reservations/base/components/BaseDrawer';
import { useBookingDetails } from 'reservations/booking/providers/BookingProvider';
import { SPECIAL_OCCASION_OPTIONS } from 'reservations/form/components/SpecialOccasionFormField';
import { useSubmitReservationDetails } from 'reservations/modify/hooks/useSumbitReservationDetails';

export const SpecialOccasionModal = () => {
  const { tags: existingTags } = useBookingDetails();
  const {
    field: { onChange, value: tags }
  } = useController({
    name: 'specialOccasion'
  });
  const onClick = useSubmitReservationDetails();

  return (
    <BaseDrawer
      header="Celebrate your special occasion!"
      subheader="Select a special occasion to make your reservation even more memorable."
      primaryButton={{
        label: !!existingTags?.length ? 'UPDATE' : 'SAVE',
        onClick
      }}
      requireAuth
    >
      <RadioGroup
        aria-labelledby="special-occasion-select"
        onChange={onChange}
        defaultValue={tags}
      >
        {SPECIAL_OCCASION_OPTIONS.map((item, index) => (
          <FormControlLabel
            key={index}
            value={item}
            control={<Radio />}
            label={item}
          />
        ))}
      </RadioGroup>
    </BaseDrawer>
  );
};
